module.exports = __webpack_public_path__ + "static/media/2.dd1ad376.png";